import React from "react";

import { Image } from "antd";
import moment from "moment";

const InquiryEachComponent = ({ inquiryValue, inquiryImageList }) => {
	const type = !!inquiryValue?.type; // true: 답변, false: 질문
	return (
		<div className={`inquiry-board-component`}>
			<div className={`inquiry-board-each-title`}>
				{!type && (
					<div className={`inquiry-button-design-group`}>
						{inquiryValue?.is_answer ? (
							<p className={`answer-blue`}>답변완료</p>
						) : (
							<p className={`answer-yet`}>답변예정</p>
						)}
						{!!inquiryValue?.is_mine && (
							<p className={`answer-success`}>내가 쓴 글</p>
						)}
					</div>
				)}
				<div className={`inquiry-board-each-title-font`}>
					{!type && !!inquiryValue?.is_secret && (
						<img
							src={`/assets/images/channel/secret-black.png`}
							alt={`비밀댓글`}
							style={{
								width: "0.9em",
								height: "auto",
							}}
						/>
					)}
					<p>{inquiryValue?.title}</p>
				</div>
				<p
					className={`gray`}
					style={{
						marginLeft: "auto",
					}}
				>
					{inquiryValue?.created_by_name}
				</p>
			</div>
			<div className={`inquiry-board-each-body`}>
				<p>{inquiryValue?.content}</p>
				{!!inquiryImageList?.length && (
					<div className={`inquiry-board-each-image-group`}>
						<Image.PreviewGroup>
							{inquiryImageList?.map((src, idx) => (
								<Image
									preview={{
										mask: <></>,
									}}
									src={src}
									alt={`문의 이미지 ${idx}`}
									key={`inquiry-each-image-${idx}`}
								/>
							))}
						</Image.PreviewGroup>
					</div>
				)}
				<p
					className={`gray`}
					style={{
						marginTop: "3em",
					}}
				>
					{moment(inquiryValue?.created_at).format("YYYY.MM.DD")}
				</p>
			</div>
		</div>
	);
};
export default InquiryEachComponent;
